import Head from 'next/head'
import CarouselSection from '../../containers/about-us/carousel-section'
import HeroSection from '../../containers/about-us/hero-section'
import InfoSection from '../../containers/about-us/info-section'
import CTACards from '../../containers/about-us/cta-cards'
import LocationInfo from '../../containers/about-us/location-info'
import Features from '../../components/features'

export default function AboutUs() {
  return (
    <>
      <Head>
        <title>Sell Your Car Online Safely, For the Most Money | About privauto</title>
        <meta
          name='description'
          content='Sell your car safely, for the most money with privauto, the best site to buy or sell a car. We cut the middle man so you save money when you buy or sell!'
        />
      </Head>

      <HeroSection />

      <div className='container'>
        <section className='infoSection'>
          <InfoSection />
        </section>

        <section className='features'>
          <Features />
        </section>
      </div>

      <section className='location'>
        <LocationInfo />
      </section>

      <section className='carouselSection'>
        <CarouselSection />
      </section>

      <div className='container'>
        <section className='ctaSection'>
          <CTACards />
        </section>
      </div>

      <style jsx>{`
        .container {
          max-width: 193rem;
          width: 100%;
          margin: 0 auto;
          padding: 0 4rem;
        }

        .infoSection {
          max-width: 153.2rem;
          width: 100%;
          margin: 5.3rem auto 8rem;
        }

        .features {
          max-width: 164.8rem;
          margin: 0 auto 8.5rem;
        }

        .location {
          margin: 0 0 20.8rem;
          padding: 4.2rem 0 4.2rem;
        }

        .purchaseInfo {
          min-height: 100rem;
          margin: 0 auto;
          padding: 0 0 15rem;
        }

        .ctaSection {
          margin: 10rem 0 8.3rem;
        }

        @media (max-width: 1024px) {
          .container {
            max-width: 100%;
            padding: 0 1.1rem;
          }

          .infoSection {
            margin: 1.5rem auto 2.7rem;
          }

          .features {
            margin: 0 auto 3.6rem;
          }

          .location {
            margin: 0 0 2.6rem;
            padding: 2.6rem 0 0;
          }

          .purchaseInfo {
            min-height: 46rem;
            padding: 0;
          }

          .ctaSection {
            margin: 2.3rem 0 0;
          }
        }
      `}</style>
    </>
  )
}

AboutUs.getInitialProps = () => ({
  namespacesRequired: ['common'],
})
